module.exports = __webpack_public_path__ + "static/media/airbaltic.60568592.svg";